<nb-card class="dialog-assign-case">
  <nb-card-header>
    Add to Folder
  </nb-card-header>
  <nb-card-body>
    <p>Please select a folder to add files:</p>
    <ng2-smart-table [settings]="settings" [source]="dataList"  (userRowSelect)="userRowSelect($event)"></ng2-smart-table>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      matRipple
      status="info"
      [disabled]="selectedCase === ''"
      (click)="AddToFolder()"
    >
      ADD
    </button>
    <button
      class="cancel"
      nbButton
      matRipple
      status="danger"
      (click)="cancel()"
    >
      CANCEL
    </button>
  </nb-card-footer>
</nb-card>
